var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeenahTmWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "80px",
    viewBox: "0 0 200 80",
    style: {
      enableBackground: "new 0 0 200 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.8,18.3c-6.2,7.5-12.4,15.1-18.5,22.6c-2.3,2.8-2.8,6.7,0,9.4c2.4,2.4,7.1,2.9,9.4,0 c6.2-7.5,12.4-15.1,18.5-22.6c2.3-2.8,2.8-6.7,0-9.4C136.9,15.9,132.2,15.4,129.8,18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.8,18.3c-2.4-2.4-7.1-2.9-9.4,0c-4,4.9-8.1,9.9-12.1,14.8c-1.7-3.9-3.4-7.7-5.2-11.6c-0.2-1-0.6-2-1.4-2.9 c-0.9-1.1-2.2-1.8-3.7-2.1c-1.9-0.4-3.9-0.2-5.4,1c-0.9,0.6-1.5,1.3-2,2.2c-3.7,4.4-7.3,8.9-11,13.3c-1.7-3.9-3.4-7.8-5.2-11.7 c-0.2-1-0.6-1.9-1.3-2.8c-0.9-1.2-2.3-2-3.8-2.2c-2-0.5-4.2-0.1-5.6,1.3c-0.7,0.6-1.3,1.3-1.7,2.1C30.9,35,18.7,50.2,6.5,65.4 c0,0,0,0-0.1,0.1c-2.3,2.9-2.8,6.7,0,9.4c2.4,2.4,7.1,2.9,9.4,0c10.5-13.1,20.9-26.1,31.3-39.2c2,4.4,3.9,8.8,5.9,13.2 c0.9,2,2.9,3,5.1,3.3c2.1,0.3,4.2-0.2,5.5-1.9c4-4.9,8-9.8,12-14.7c2,4.4,3.9,8.9,5.9,13.3c0.9,2,3,3.1,5.2,3.3 c2.1,0.3,4.1-0.2,5.5-1.9c6.2-7.5,12.4-15.1,18.5-22.6C113.1,24.9,113.5,21,110.8,18.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 145.8,
    cy: 9,
    rx: 6.7,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8,53.2c-3.7,0-6.7,2.9-6.7,6.7c0,1.7,0.6,3.3,1.7,4.4c-1-0.5-2-0.8-3.1-0.8c-3.7,0-6.7,2.9-6.7,6.7 c0,3.7,2.9,6.7,6.7,6.7c3.7,0,6.7-2.9,6.7-6.7c0-1.7-0.6-3.3-1.7-4.4c1,0.5,2,0.8,3.1,0.8c3.7,0,6.7-2.9,6.7-6.7 C82.4,56.2,79.4,53.2,75.8,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.4,45c3.7,0,6.7-2.9,6.7-6.7c0-1.7-0.6-3.3-1.7-4.4c1,0.5,2,0.8,3.1,0.8c3.7,0,6.7-2.9,6.7-6.7 c0-3.7-2.9-6.7-6.7-6.7c-3.7,0-6.7,2.9-6.7,6.7c0,1.7,0.6,3.3,1.7,4.4c-1-0.5-2-0.8-3.1-0.8c-3.7,0-6.7,2.9-6.7,6.7 C6.8,42,9.7,45,13.4,45z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 89,
    cy: 9,
    r: 6.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,76.6H90.5c-0.8,0-1.6-0.5-1.8-1.2c-0.3-0.7-0.2-1.6,0.4-2.2l9.2-9.5h-7.7c-1.1,0-2.1-0.9-2.1-2.1 c0-1.1,1-2.1,2.1-2.1h12.5c0.8,0,1.6,0.5,1.8,1.3c0.3,0.7,0.2,1.6-0.4,2.1l-9.2,9.6h7.7c1.1,0,2.1,1,2.1,2.1S104.1,76.6,103,76.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.2,69.1h-10.5c0.5,1.9,2.2,3.4,4.3,3.4c1.1,0,2.7-0.5,3.6-1.3c0.8-0.8,2.1-0.8,2.9,0s0.8,2.1,0,2.9 c-1.8,1.8-4.4,2.4-6.4,2.4c-4.7,0-8.5-3.8-8.5-8.5s3.7-8.5,8.5-8.5c0.5,0,1,0,1.5,0.2c2.3,0.5,4.3,1.9,5.5,3.9 c0.6,1,1.2,2.2,1.1,3.3c0,0.3-0.2,0.6-0.2,1C122.6,68.5,122,69.1,121.2,69.1z M111.3,65.7h7.2c-0.7-1.3-1.9-2.1-3.5-2.1 C113.5,63.6,112.1,64.4,111.3,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.8,69.1h-10.5c0.5,1.9,2.2,3.4,4.3,3.4c1.1,0,2.7-0.5,3.6-1.3c0.8-0.8,2.1-0.8,2.9,0 c0.8,0.8,0.8,2.1,0,2.9c-1.8,1.8-4.4,2.4-6.4,2.4c-4.7,0-8.5-3.8-8.5-8.5s3.7-8.5,8.5-8.5c0.5,0,1,0,1.5,0.2 c2.3,0.5,4.3,1.9,5.5,3.9c0.6,1,1.2,2.2,1.1,3.3c0,0.3-0.2,0.6-0.2,1C140.1,68.5,139.6,69.1,138.8,69.1z M128.9,65.7h7.2 c-0.7-1.3-1.9-2.1-3.5-2.1C131.1,63.6,129.7,64.4,128.9,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,68v6.4c0,1.1-0.9,2.1-2,2.1s-2.1-1-2.1-2.1V68c0-2.4-1.7-4.4-3.9-4.4c-2.6,0-4,2.6-4,5v5.8 c0,1.1-1,2.1-2.1,2.1s-2.1-1-2.1-2.1v-13c0-1.1,1-2.1,2.1-2.1c0.9,0,1.6,0.6,1.9,1.4c1.2-0.8,2.6-1.2,4.1-1.2 C155,59.6,158.5,63.3,158.5,68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.6,61.5v13c0,1-0.9,1.9-2,1.9s-1.8-0.9-1.8-1.9v-0.4c-1.4,1.3-3.2,2-5.2,2c-4.5,0-8.2-3.7-8.2-8.2 s3.7-8.2,8.2-8.2c2.1,0,3.7,0.8,5.2,2v-0.2c0-1,0.7-1.9,1.8-1.9C176.7,59.5,177.6,60.4,177.6,61.5z M172.8,67.8 c0-2.3-1.9-4.2-4.2-4.2s-4.3,1.9-4.3,4.2s1.9,4.2,4.3,4.2C170.9,72,172.8,70.2,172.8,67.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196,74.6c0,1.1-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1v-7.5c0-1.9-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5v7.5 c0,1.1-0.9,2.1-2.1,2.1c-1.1,0-2.1-1-2.1-2.1V52.9c0-1.1,1-2.1,2.1-2.1c1.2,0,2.1,1,2.1,2.1v7.5c1-0.6,2.2-0.9,3.5-0.9 c4.2,0,7.6,3.4,7.6,7.6v7.5H196z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeenahTmWhite);
export default __webpack_public_path__ + "static/media/zeenah_tm_white.d9c6264d6cd2f6382ba5e0aac738c688.svg";
export { ForwardRef as ReactComponent };